module.exports = __webpack_public_path__ + "media/images/flags/4x3/irn-84e05fc18c71a755e7fe8b57d223e1a1.svg";